(function() {

  window.SideCart = window.SideCart || new function() {
    //runs once per page load
    var self = this;
    var isOpen = false;
    
    document.addEventListener('click', function(event){
      if (event.target.id === "overlay") self.hideSideCart();
    });

    self.getCartLineItemsCount = function(){
      var cart = document.getElementById('side-cart');
      var itemsCount = 0;
      cart.querySelectorAll('.item').forEach(function(item){
        itemsCount++;
      });
      return itemsCount;
    }

    self.isVariantIdInCart = function(variantId){
      var cart = document.getElementById('side-cart');
      var itemsCount = 0;
      cart.querySelectorAll('.item').forEach(function(item){
        if(item.dataset.variantId == variantId) {
          itemsCount++;
        }
      });
      console.log(itemsCount)
      return itemsCount > 0;
    }

    self.updateSideCart = function(open) {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=side_cart', success: function(data){
        var section = document.getElementById('shopify-section-side_cart');
        if (section)
          section.parentNode.removeChild(section);
        document.body.insertAdjacentHTML("beforeend", data["side_cart"]);
        $s.globalEval(data["side_cart"]);
        if (open) {
          self.showSideCart(!isOpen);
        }
        $s.hideLoadingOverlay();
      }});
    }

    self.isCartOpen = function() {
      return isOpen;
    }
    
    self.showSideCart = function(animate) {
      $s.closeModal();

      isOpen = true;
      var sideCart = document.getElementById('side-cart');
      $s.showOverlay()
      if(animate) {
        setTimeout(function(){sideCart.classList.add('open')}, 100);
      } else {
        sideCart.classList.remove('ease-animation-slow');
        sideCart.classList.add('open');
        setTimeout(function(){sideCart.classList.add('ease-animation-slow')}, 200);
      }
      $s.trapFocus(sideCart);

      /// Animate progress bar when sidecart open
      var progressBar =  document.querySelector(".free-shipping-progress-bar .progress");
      if (!progressBar) return false;
      var progressValue = progressBar.getAttribute("data-progress");
      setTimeout(function(){
        progressBar.style.width = progressValue+'%';
      }, 1000);
    };

    self.hideSideCart = function() {
      isOpen = false;
      var sideCart = document.getElementById('side-cart');
      $s.hideOverlay();
      sideCart.classList.remove('open');
      $s.removeTrapFocus();
      /// Animate progress bar when sidecart Close
      var progressBar =  document.querySelector(".free-shipping-progress-bar .progress");
      if (!progressBar) return false;
      setTimeout(function(){
        progressBar.style.width = 0;
      }, 1000);
    };

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset ? item.dataset.key : item.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: $s.addToCartSuccess,
        error: $s.addToCartFail
      });
    }

    window.addEventListener('keydown', function(e){
      if (e.which == 27) { //Exit
        var sideCart = document.getElementById('side-cart');
        if(sideCart.classList.contains('open')){
          e.preventDefault();
          window.SideCart.hideSideCart();
          return false;
        }
      }
    });
  
  };

  //runs every time #side-cart div is replaced
  var sideCart = document.getElementById('side-cart');
  var itemsCount = 0;

  

  

  

  sideCart.querySelectorAll('input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate(this.closest('.item'), this.value);
      SideCart.updateItemsQuantity(items, this.value);
    });
  });let wait = setInterval(function () { 
    if(document.querySelectorAll("#side-cart .item").length === 0) {
      clearInterval(wait)
      return
    }
    clearInterval(wait)
  window.condition = false;
   window.condition = [...document.querySelectorAll("#side-cart .item")].every(item=>{
    if(item.innerHTML.toLowerCase().includes("add on")){
      
      return true 
    }else{return false}
})
  
  if(condition){
  
  const elems = document.querySelectorAll("#side-cart .item")
  
    SideCart.updateItemsQuantity(elems, 0);

  
  }
   },500)
  
  //$s.validateBundlesInHTML(document.querySelectorAll('#side-cart .item'));
  
})();